import { Component, OnInit, ElementRef, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NotBlankGenericFieldValidator } from '../../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../../validations/date-text-field.validator'
import { DataEntryStep1 } from '../../../models/data-entry-step1'
import { ValidatedRadioButtonModel } from '../../../../validations/validated-radio-button-group.component'
import { EnrollmentGateway } from '../../../gateways/enrollment-gateway'
import { PortalGlobals } from '../../../../portalglobals'
import { EnrollmentViewModel } from '../../../models/enrollment-view-model'
import { ValidAgent } from '../../../models/valid-agent'
import { GoodStandingModel } from '../../../../common/models/good-standing-model'
import * as moment from 'moment'
import { DrugPlan } from '../../../models/drug-plan'
import { PlanList } from '../../../models/plan-list'
import { ValidatedSelectOptionModel } from '../../../../validations/validated-dropdown.component'
import { ValidatedSelectOptionModel as State } from '../../../../validations/validated-dropdown.component'
import { PhoneNumberInputMask } from '../../../../common/input-masks/phone-number.input-mask'
import { EmailAddressTextFieldValidator } from '../../../../validations/email-address-text-field-validator'
import { LengthTextFieldValidator } from '../../../../validations/length-text-field-validator'
import { RequiredRadioButtonFieldValidator } from '../../../../validations/required-radio-button-field-validator'
import { AccountTypes, PaymentAccount } from '../../../models/payment-account'
import { isMMDDYYYY } from '../../../../../app/validations/is-mmddyyyy'
import { SubmitEnrollmentDataResponse } from '../../../models/submit-enrollment-data-response'
import { NetworkStateGateway } from './../../../../common/gateways/network-state-gateway'
import { NumericTextFieldValidator } from '../../../../validations/numeric-text-field-validator'
import { AlphaNumericFieldValidator } from '../../../../validations/alpha-numeric-field-validator'
import { GetEnrollmentDataResponse, GetEnrollmentDataByID } from '../../../models/get-enrollment-data-response'
import { EnrollmentCacheData } from '../../../models/EnrollmentCacheData'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'NEJESingleGroupStep2',
    templateUrl: 'single-group-step2.component.html'
})
export class NEJESingleGroupStep2Component implements OnInit {
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    dataEntryStep1 = {} as DataEntryStep1
    alphaNumericFieldValidator: AlphaNumericFieldValidator = new AlphaNumericFieldValidator()
    public RelCode: ValidatedSelectOptionModel[] = []
    public PersonCode: ValidatedSelectOptionModel[] = []
    isValidAgent: boolean
    isFormValid: boolean
    selFaxContactType: string
    //dateofReceiptInvalid: boolean
    //ContactTypeInvalid: boolean
    showMLPAP: boolean
    showSTCOBFields: boolean = false
    //  public optionrbConactType: ValidatedRadioButtonModel[] = []
    // optionrbEnrollmentMethod: ValidatedRadioButtonModel[] = []
    // optionrbScope: ValidatedRadioButtonModel[] = []
    selEnrollmentMethod: string
    ErrorMessages: any[]
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    agentUserName: string
    hasError: boolean
    EnrollmentMethodError: boolean
    // SOAError: boolean
    validAgentModel: ValidAgent
    // CUID: string
    //AgentID: string
    //AdminID: number
    errorMessage: any[]
    IsErrorMesssage: boolean = false
    public loading: boolean = false
    goodStandingValues: GoodStandingModel = {} as GoodStandingModel
    planList: PlanList[] = [] as PlanList[]
    drugPlanModel = {} as DrugPlan
    selPlan: string
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    public optionrbPlan: ValidatedRadioButtonModel[] = []
    genderOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    titleOptions: ValidatedSelectOptionModel[] = [] as ValidatedSelectOptionModel[]
    titleOption: string = ''
    genderOption: string = ''
    IsSameAddress: boolean
    states: State[] = [] as State[]
    mailingstates: State[] = [] as State[]
    public emergencycontactOptions: ValidatedRadioButtonModel[] = []
    public rblSecondaryCoverage: ValidatedRadioButtonModel[] = []
    IsCovergInfoYes: boolean
    IsCovergInfotext: boolean
    phoneNumberInputMask = new PhoneNumberInputMask()
    lengthValidator = new LengthTextFieldValidator(10)
    periodSelected = ''
    reasonCode: string = ''
    dateField: boolean
    isAEPVisible: boolean
    public IsAutomatciSocial: boolean
    public IsAUTOMATIC_RAILROAD: boolean
    public IsElectronicFund: boolean
    public IsMonthly: boolean
    public IsRblLISYes: boolean
    public IsRblLISNo: boolean
    IsSelectPlan: boolean
    IsRbllongtermYes: boolean
    IsEmergencyYes: boolean
    hasIncompleteError: boolean
    isIndv: boolean
    disabledstate = false
    visibleFrom2025: boolean
    visibleFrom2026: boolean
    isPOBox:boolean 
    baseTitle: string

    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()
    paymentOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    electionPeriodsList: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    public rbllongTerm: ValidatedRadioButtonModel[] = []
    accountTypeOptions: ValidatedRadioButtonModel[] = Object.keys(AccountTypes).map((accountTypeKey) => {
        return { value: accountTypeKey, htmlLabel: AccountTypes[accountTypeKey] }
    })

    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    // PaperlessOption: boolean
    emailLabel: string
    // eobOptionLabel: string

    constructor(
        private router: Router,
        private _enrollementGateway: EnrollmentGateway,
        private _stateGateway: NetworkStateGateway,
        public _global: PortalGlobals,
        private titleService: Title
    ) {
        // this.optionrbConactType.push({ value: 'Mail', htmlLabel: 'Mail' }, { value: 'Fax', htmlLabel: 'Fax' })
        //  this.optionrbEnrollmentMethod.push({ value: 'Mail', htmlLabel: 'I received a paper application in the mail' }, { value: 'Paper', htmlLabel: 'I completed a paper application in a face to face meeting with the beneficiary' })
        //  this.optionrbScope.push({ value: 'ScopeIncluded', htmlLabel: 'A Scope of Appointment is included with this enrollment form' }, { value: 'ScopeNotIncluded', htmlLabel: 'Scope of Appointment was NOT completed because the agent did not have an individual or one-on-one marketing appointment (whether in person, telephonically or otherwise) with the applicant.' })
        this.emergencycontactOptions.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblSecondaryCoverage.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rbllongTerm.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.RelCode.push(
            { text: 'Not Specified', value: '00' },
            { text: 'Employee', value: '01' },
            { text: 'Spouse', value: '02' },
            { text: 'Child', value: '03' },
            { text: 'Other', value: '04' }
        )
        this.PersonCode.push(
            { text: 'Card Holder', value: '01' },
            { text: 'Spouse', value: '02' },
            { text: 'First Dependent', value: '03' },
            { text: 'Second Dependent', value: '04' }
        )
        this.errorMessage = []
        this.IsSameAddress = true
        if (this._global.selectedPlanYear > this._global.Planyear2025) {
            this.visibleFrom2026 = true;
        }
        // this.eobOptionLabel = 'Yes, I want to go paperless for all available and future documents'
    }

    relationChange(event: any) {
        this.enrollmentViewModel.RELCD = event
        this.enrollmentViewModel.RELTEXT = this.RelCode.filter((x) => x.value === event)[0].text
    }

    personChange(event: any) {
        this.enrollmentViewModel.PERSONCD = event
        this.enrollmentViewModel.PERSONTEXT = this.PersonCode.filter((x) => x.value === event)[0].text
    }

    ngOnDestroy(): void {
        this.titleService.setTitle(this.baseTitle)
    }

    ngOnInit() {

        // Set unique title
        this.baseTitle = this.titleService.getTitle();
        this.titleService.setTitle(this.baseTitle + ' - Employer Group Enrollment')

        this.hasError = false
        this.isIndv = false
        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
        this.enrollmentViewModel.ISBACK = false
        this.ErrorMessages = [] as any[]
        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (this.enrollmentViewModel === null || this.enrollmentViewModel === undefined) {
            this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step1'])
        }
        if (
            this.enrollmentViewModel.POVERIND !== undefined &&
            this.enrollmentViewModel.POVERIND != null &&
            this.enrollmentViewModel.POVERIND != '' &&
            this.enrollmentViewModel.POVERIND === '1') {
            this.poBoxChecked(true)
        }
        else {
            this.poBoxChecked(false)
        }

        //Get the Paperless settings from config
        /*
        this._enrollementGateway.getPaperlessSetting("NEJESingleGroupPaperlessSetting").subscribe(
            data => {
                this.PaperlessOption = data
                this.enrollmentViewModel.PaperlessSettings = data
                if (this.PaperlessOption) {
                    if (this.enrollmentViewModel.EOB === undefined || this.enrollmentViewModel.EOB == null) {
                        this.eobOptionChanged(false)
                    } else {
                        this.eobOptionChanged(this.enrollmentViewModel.EOB === '3')
                    }
                }
            })
        */

        if (this.enrollmentViewModel.AGENTID === null || this.enrollmentViewModel.AGENTID === undefined || this.enrollmentViewModel.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)

                this.loading = true
                this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                    (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                        this.enrollmentViewModel.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                        this.enrollmentViewModel.ADMINID = this.enrollmentCacheData.AdminID
                        this.enrollmentViewModel.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                        this.enrollmentViewModel.AGENTNAME = this.enrollmentCacheData.AgentName
                        this.enrollmentViewModel.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                        this.enrollmentViewModel.USERNAME = this.enrollmentCacheData.USERNAME
                        this.enrollmentViewModel.ISSTCOB = this.enrollmentCacheData.ISSTCOB
                        this.enrollmentViewModel.SINGLEGRPNAME = this.enrollmentCacheData.GroupPlanName
                        this.enrollmentViewModel.SEPREASONTEXT = this.enrollmentCacheData.SEPREASONTEXT
                        this.enrollmentViewModel.RBLLONGTERM = this.enrollmentCacheData.RBLLONGTERM
                        this.enrollmentViewModel.ISSINGLEGROUP = this.enrollmentCacheData.ISSINGLEGROUP
                        this.enrollmentViewModel.CHANNELID = this.enrollmentCacheData.CHANNELID

                        //this.enrollmentViewModel.PaperlessSettings = this.enrollmentCacheData.PaperlessSettings
                        this.enrollmentViewModel.STCOBGROUPNAME = this.enrollmentCacheData.STCOBGROUPNAME
                        this.LoadData()

                        this.loading = false
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step1'])
            }
        } else {
            this.LoadData()
        }
    }

    /*
    eobOptionChanged(option: boolean) {
        if (option) {
            this.emailLabel = 'Email Address (Required for Paperless)'
            this.enrollmentViewModel.EOB = '3'
        } else {
            this.emailLabel = 'Email Address (Optional)'
            this.enrollmentViewModel.EOB = 'N'
        }
    }
    */

    LoadData(): void {
        this.agentUserName = this.enrollmentViewModel.AGENTNAME

        this.dataEntryStep1.AgentName = this.enrollmentViewModel.AGENTNAME
        this.isValidAgent = true
        this.setValue()

        this.showSTCOBFields = this.enrollmentViewModel.ISSTCOB
        this.enrollmentViewModel.ELECTION = 'Special'
        this.enrollmentViewModel.SEPREASONCD = 201
        this.enrollmentViewModel.SEPREASONTEXT = 'I am leaving/losing/joining employer or union coverage. My coverage changed or will change on'

        if (this._global.selectedPlanYear > this._global.Planyear2024) {
            this.visibleFrom2025 = true
        }
    }

    poBoxChecked(option: boolean) {
        if (option) {
            this.enrollmentViewModel.POVERIND = '1'
            this.isPOBox = true
        }
        else {
            this.enrollmentViewModel.POVERIND = '0'
            this.isPOBox = false
        }

    }
    appRecievedDateChange(event: any) {
        this.enrollmentViewModel.APPDT = event
        if (this.enrollmentViewModel.APPDT !== undefined && this.enrollmentViewModel.APPDT !== null) {
            this.enrollmentViewModel.SEPEFFDT = this.enrollmentViewModel.APPDT
        }
    }

    setValue(): void {
        this.genderOptions = [
            { value: 'M', htmlLabel: 'Male' },
            { value: 'F', htmlLabel: 'Female' }
        ]
        this.titleOptions = [
            { value: 'MR', text: 'MR' },
            { value: 'MRS', text: 'MRS' },
            { value: 'DR', text: 'DR' },
            { value: 'MS', text: 'MS' }
        ]
        this.loadPlanList()
        this.electionPeriodsList = [
            {
                value: 'Special',
                htmlLabel: 'Special'
            }
        ]
        this.paymentOptions = [
            {
                value: 'Direct Bill',
                htmlLabel: 'Receive a bill'

                //},
                //{
                //    value: 'Automatic Bank Draft Withdrawal',
                //    htmlLabel: 'Automatic Bank Draft Withdrawal from Checking or Savings Account',

                //},
                //{
                //    value: 'Deduction from Social Security Check',
                //    htmlLabel: 'Automatic deduction from your monthly Social Security benefit check OR',

                //},
                //{
                //    value: 'Deduction from Railroad Retirement Board',
                //    htmlLabel: 'Automatic deduction from your monthly Railroad Retirement Board benefit check',
            }
        ]
        this.paymentOptionChanged(this.enrollmentViewModel.PWO)
        if (this.enrollmentViewModel.ISSAMEADDRESS !== null && this.enrollmentViewModel.ISSAMEADDRESS !== undefined) {
            //this.clickOnSameAsBusinessAddress(this.enrollmentViewModel.ISSAMEADDRESS)
        }
        //if (this.enrollmentViewModel.AGENTORGID !== null && this.enrollmentViewModel.AGENTORGID !== undefined) {
        //    this._enrollementGateway.GetAllParentStatesForOrg(this.enrollmentViewModel.AGENTORGID).subscribe(
        //        (states: ValidatedSelectOptionModel[]) => {
        //            states.unshift({ value: 0, text: '-- Choose One --', })
        //            //  this.mailingstates = states
        //            this.states = states
        //            if (this.enrollmentViewModel.APPST === undefined || this.enrollmentViewModel.APPST === '' || this.enrollmentViewModel.APPST === '0' || this.enrollmentViewModel.APPST === null) {
        //                this.enrollmentViewModel.APPST = '0'
        //            }
        //            else {
        //                this.disabledstate = true
        //            }

        //            //this.mailingstates.unshift({ value: 0, text: '-- Choose One --', })

        //        }

        //    )
        //}
        this._stateGateway.getAllStatesforMailing().subscribe((states: State[]) => {
            states.unshift({ value: 0, text: '-- Choose One --' })
            this.mailingstates = states
            this.states = states
            this.disabledstate = false
            if (
                this.enrollmentViewModel.MAILST === undefined ||
                this.enrollmentViewModel.MAILST === '' ||
                this.enrollmentViewModel.MAILST === '0' ||
                this.enrollmentViewModel.MAILST === null
            ) {
                this.enrollmentViewModel.MAILST = '0'
            }
        })
        let today = new Date()
        //if (this.enrollmentViewModel.APPDT === null || this.enrollmentViewModel.APPDT === undefined) {
        //    this.enrollmentViewModel.APPDT = today
        //}
        if (
            this.enrollmentViewModel.ELECTION !== '' &&
            this.enrollmentViewModel.ELECTION !== null &&
            this.enrollmentViewModel.ELECTION !== undefined
        ) {
            this.periodSelectdChanged(this.enrollmentViewModel.ELECTION)
        }
        if (this.enrollmentViewModel.OTHCVRG !== '' && this.enrollmentViewModel.OTHCVRG !== null && this.enrollmentViewModel.OTHCVRG !== undefined) {
            this.ShowCoverageInfo(this.enrollmentViewModel.OTHCVRG)
        }
        if (
            this.enrollmentViewModel.RBLLONGTERM !== '' &&
            this.enrollmentViewModel.RBLLONGTERM !== null &&
            this.enrollmentViewModel.RBLLONGTERM !== undefined
        ) {
            this.ShowrbllongtermOptions(this.enrollmentViewModel.RBLLONGTERM)
        }
        if (this.enrollmentViewModel.ISSINGLEGROUP !== null && this.enrollmentViewModel.ISSINGLEGROUP !== undefined) {
            if (this.enrollmentViewModel.ISSINGLEGROUP) {
                this.isIndv = true
            }
        }
        if (this.enrollmentViewModel.APPST !== '' && this.enrollmentViewModel.APPST !== null && this.enrollmentViewModel.APPST !== undefined) {
            this.SelectState(this.enrollmentViewModel.APPST)
        }
        if (this.enrollmentViewModel.EMERIND !== '' && this.enrollmentViewModel.EMERIND !== null && this.enrollmentViewModel.EMERIND !== undefined) {
            this.ShowrEmergencyContactOptions(this.enrollmentViewModel.EMERIND)
        }
    }
    onContinue(): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step1'])
    }

    SelectState(selectstate: string) {
        //if (selectstate !== '' && selectstate !== undefined && selectstate !== '0') {
        //    this.planstatename = selectstate
        //}
        this.enrollmentViewModel.APPST = selectstate
        //  if (this.states !== undefined && this.states !== null) {
        //  if (this.states.length > 0)
        //  this.planstatename = this.states.filter(x => x.value === selectstate)[0].text

        //   }
        this.disabledstate = false
    }

    formSubmit(): void {
        this.hasError = false;
        this.ErrorMessages = [] as any[]

        // SUBMISSIONTYPECODE='PROSPECT' Only for Step 1 & 2 & 3 for enrollment
        this.enrollmentViewModel.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollmentViewModel.STEPCODE = '2'
        this.enrollmentViewModel.PLANYEAR = String(this._global.selectedPlanYear)
        this.enrollmentViewModel.LANG = 'english'

        if (this.enrollmentViewModel.PWO !== 'Automatic Bank Draft Withdrawal') {
            this.resetBankDeatils()
        }
        if (this.enrollmentViewModel.EMERIND !== null && this.enrollmentViewModel.EMERIND !== undefined) {
            if (this.enrollmentViewModel.EMERIND.toUpperCase() === 'NO') {
                this.resetEmergencyDeatils()
            }
        }
        if (this.enrollmentViewModel.COBEFFDT === undefined) {
            this.enrollmentViewModel.COBEFFDT = null
        }
        if (this.enrollmentViewModel.COBTERMDT === undefined) {
            this.enrollmentViewModel.COBTERMDT = null
        }
        if (this.enrollmentViewModel.OTHCVRG !== null && this.enrollmentViewModel.OTHCVRG !== undefined) {
            if (this.enrollmentViewModel.OTHCVRG.toUpperCase() === 'NO') {
                this.enrollmentViewModel.COBBIN = ''
                this.enrollmentViewModel.COBPCN = ''
                this.enrollmentViewModel.OTHCVRGNAME = ''
                this.enrollmentViewModel.OTHCVRGID = ''
                this.enrollmentViewModel.OTHCVRGGRP = ''
                this.enrollmentViewModel.COBTERMDT = null
                this.enrollmentViewModel.COBEFFDT = null
            }
        }
        if (this.enrollmentViewModel.RBLLONGTERM !== null && this.enrollmentViewModel.RBLLONGTERM !== undefined) {
            if (this.enrollmentViewModel.RBLLONGTERM.toUpperCase() === 'NO') {
                this.enrollmentViewModel.LTCFACILITY = ''
                this.enrollmentViewModel.LTCADD1 = ''
                this.enrollmentViewModel.LTCPHONE = ''
            }
        }
        if (this.enrollmentViewModel.ISSAMEADDRESS) {
            this.enrollmentViewModel.MAILADD1 = this.enrollmentViewModel.APPADD1
            this.enrollmentViewModel.MAILADD2 = this.enrollmentViewModel.APPADD2
            this.enrollmentViewModel.MAILCITY = this.enrollmentViewModel.APPCITY
            this.enrollmentViewModel.MAILST = this.enrollmentViewModel.APPST
            this.enrollmentViewModel.MAILZIP = this.enrollmentViewModel.APPZIP
        }
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)

        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        setTimeout(() => {
            if (!this.isFormInvalid()) {
                this.loading = true

                //  this.loading = false
                //  this.router.navigate(['enrollment/neje/data-entry/Step3'])

                let mailStateCode = this.enrollmentViewModel.MAILST
                let mailZip = this.enrollmentViewModel.MAILZIP
                if (this.enrollmentViewModel.SAMEADDRESS) {
                    mailStateCode = '0'
                    mailZip = '0'
                }
                this._enrollementGateway.validateZip(this.enrollmentViewModel.APPST, this.enrollmentViewModel.APPZIP, mailStateCode, mailZip).subscribe(
                    (model: string[]) => {
                        if (model !== undefined && model !== null && model.length !== 0) {
                            this.ErrorMessages = model
                            this.hasError = true
                            this.focusableEleTop.nativeElement.focus()
                            this.loading = false
                        } else {
                            if (this.enrollmentViewModel.ENROLLKEY !== undefined && this.enrollmentViewModel.ENROLLKEY !== '') {
                                console.log('EnrollmentKey: ' + this.enrollmentViewModel.ENROLLKEY)
                                this.loading = true
                                this._enrollementGateway.UpdateEnrollmentData(this.enrollmentViewModel).subscribe(
                                    (model: SubmitEnrollmentDataResponse) => {
                                        let response = model
                                        if (response !== undefined) {
                                            if (response.Errors !== undefined && response.Errors.length > 0) {
                                                this.hasError = true

                                                for (let i = 0; i < response.Errors.length; i++) {
                                                    this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                                }
                                                this.focusableEleTop.nativeElement.focus()
                                            } else {
                                                //this.enrollment.ENROLLKEY = response.EnrollmentKey
                                                //this.enrollment.CONF = response.confirmationNumber
                                                this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                                                this.loading = false
                                                this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step3'])
                                            }
                                        } else {
                                            this.ErrorMessages.push('Error while submitting data, please try again.')
                                            this.hasError = true
                                            this.focusableEleTop.nativeElement.focus()
                                        }
                                        this.loading = false
                                    },
                                    (err) => {
                                        this.loading = false
                                    }
                                )
                            } else {
                                this.loading = true
                                this._enrollementGateway.SubmitEnrollmentData(this.enrollmentViewModel).subscribe(
                                    (model: SubmitEnrollmentDataResponse) => {
                                        let response = model
                                        if (response !== undefined) {
                                            if (response.Errors !== undefined && response.Errors.length > 0) {
                                                this.hasError = true

                                                for (let i = 0; i < response.Errors.length; i++) {
                                                    this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                                }
                                                this.hasError = true
                                                this.focusableEleTop.nativeElement.focus()
                                            } else {
                                                if (
                                                    response.EnrollmentKey !== undefined &&
                                                    response.EnrollmentKey !== '' &&
                                                    response.EnrollmentKey !== null
                                                ) {
                                                    this.enrollmentViewModel.ENROLLKEY = response.EnrollmentKey
                                                    this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                                                    this.loading = false

                                                    this.enrollmentCacheData.EnrollmentKey = response.EnrollmentKey
                                                    this.enrollmentCacheData.AgentName = this.enrollmentViewModel.AGENTNAME
                                                    this.enrollmentCacheData.AgentID = this.enrollmentViewModel.AGENTID
                                                    this.enrollmentCacheData.AdminID = this.enrollmentViewModel.ADMINID
                                                    this.enrollmentCacheData.AgentOrgID = this.enrollmentViewModel.AGENTORGID
                                                    this.enrollmentCacheData.PLANTYPENAME = this.enrollmentViewModel.PLANTYPENAME
                                                    this.enrollmentCacheData.USERNAME = this.enrollmentViewModel.USERNAME
                                                    this.enrollmentCacheData.ISSTCOB = this.enrollmentViewModel.ISSTCOB
                                                    this.enrollmentCacheData.GroupPlanName = this.enrollmentViewModel.SINGLEGRPNAME
                                                    this.enrollmentCacheData.SEPREASONTEXT = this.enrollmentViewModel.SEPREASONTEXT
                                                    this.enrollmentCacheData.RBLLONGTERM = this.enrollmentViewModel.RBLLONGTERM
                                                    this.enrollmentCacheData.ISSINGLEGROUP = this.enrollmentViewModel.ISSINGLEGROUP
                                                    this.enrollmentCacheData.CHANNELID = this.enrollmentViewModel.CHANNELID

                                                    //this.enrollmentCacheData.PaperlessSettings = this.enrollmentViewModel.PaperlessSettings
                                                    this.enrollmentCacheData.STCOBGROUPNAME = this.enrollmentViewModel.STCOBGROUPNAME
                                                    sessionStorage.setItem('EnrollmentCache', JSON.stringify(this.enrollmentCacheData))

                                                    this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step3'])
                                                } else {
                                                    this.ErrorMessages.push('Error while submitting data, please try again.')
                                                    this.hasError = true
                                                    this.focusableEleTop.nativeElement.focus()
                                                }
                                            }
                                        } else {
                                            this.ErrorMessages.push('Error while submitting data, please try again.')
                                            this.hasError = true
                                            this.focusableEleTop.nativeElement.focus()
                                        }
                                        this.loading = false
                                    },
                                    (err) => {
                                        this.loading = false
                                    }
                                )
                            }
                        }
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                this.focusableEleTop.nativeElement.focus()
            }
        }, 10);
        
    }

    validateFutureDate(recdate: string): Boolean | undefined {
        var currentDate = new Date()
        let receiptdate = moment(recdate).toDate()
        if (receiptdate > currentDate) {
            return false
        }
    }
    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }
    onPlanChange(planType: string) {
        if (planType !== undefined && planType !== '' && planType !== null) {
            this.enrollmentViewModel.PLANTYPE = planType
            if (this.optionrbPlan !== undefined && this.optionrbPlan !== null) {
                if (this.optionrbPlan.length > 0)
                    this.enrollmentViewModel.PLANTYPENAME = this.optionrbPlan.filter((x) => x.value === planType)[0].htmlLabel
            }
        }
    }
    loadPlanList() {
        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
        let planyear
        if (this.enrollmentViewModel.PLANYEAR !== undefined) planyear = this.enrollmentViewModel.PLANYEAR
        else planyear = this._global.selectedPlanYear

        this._enrollementGateway.getPlanList(parseInt(this._global.currentUser.orgId), planyear).subscribe((model: PlanList[]) => {
            this.planList = model
            this.getPlanList(this.planList)
        })
    }

    private getPlanList(planLst: PlanList[]) {
        this.optionrbPlan = planLst.map(this.buildPlanOption.bind(this))
        this.optionrbPlan = this.optionrbPlan.reverse()
    }

    private buildPlanOption(plan: PlanList): ValidatedRadioButtonModel {
        return {
            value: plan.PlanTypeShortName,
            htmlLabel: plan.PlanTypeName
        }
    }
    clickOnSameAsBusinessAddress(val: boolean) {
        if (val) {
            this.IsSameAddress = false
            this.enrollmentViewModel.MAILADD1 = this.enrollmentViewModel.APPADD1
            this.enrollmentViewModel.MAILADD2 = this.enrollmentViewModel.APPADD2
            this.enrollmentViewModel.MAILCITY = this.enrollmentViewModel.APPCITY
            this.enrollmentViewModel.MAILST = this.enrollmentViewModel.APPST
            this.enrollmentViewModel.MAILZIP = this.enrollmentViewModel.APPZIP
        } else {
            this.IsSameAddress = true
            this.enrollmentViewModel.MAILADD1 = ''
            this.enrollmentViewModel.MAILADD2 = ''
            this.enrollmentViewModel.MAILCITY = ''
            this.enrollmentViewModel.MAILST = ''
            this.enrollmentViewModel.MAILZIP = ''
        }

        this.enrollmentViewModel.ISSAMEADDRESS = val
    }
    onBlur() {}
    onBack(): void {
        this.enrollmentViewModel.ISBACK = true
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step1'])
    }

    periodSelectdChanged(period: string) {
        this.periodSelected = this.enrollmentViewModel.ELECTION = period
        let currDate = new Date()
        if (this.periodSelected === 'OpenEnrollment') {
            if (this.enrollmentViewModel.EFFDT != new Date(currDate.getFullYear() + 1, 0, 1)) {
                if (currDate.getMonth() > 3) this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
            }
            //  this.disableEffectiveDate = true
        }
    }
    reasonCodeChanged(SelReasonCode: any) {
        this.enrollmentViewModel.SEPREASONTEXT = SelReasonCode.text
        this.enrollmentViewModel.ELECTIONTYPEID = SelReasonCode.id
        this.enrollmentViewModel.SEPREASONCD = SelReasonCode.value
        this.reasonCode = this.enrollmentViewModel.ELECTIONTYPEID + '|' + this.enrollmentViewModel.SEPREASONCD
        this.reasonCode = SelReasonCode.id + '|' + SelReasonCode.value
    }
    hasDateField(datefield: boolean) {
        this.dateField = datefield
    }
    sepdatechange(option: Date) {
        this.enrollmentViewModel.SEPEFFDT = option
    }
    AEPVisible(event: any) {
        if (event) {
            this.isAEPVisible = true
        }
    }
    paymentOptionChanged(option: string) {
        // this.enrollment.PWO = option
        // this.onPaymentOptionChange.emit(option)
        if (option === 'Deduction from Social Security Check') {
            this.IsAutomatciSocial = true
            this.IsAUTOMATIC_RAILROAD = false
            this.IsElectronicFund = false
            this.IsMonthly = false
            this.IsSelectPlan = false
        }
        if (option === 'Deduction from Railroad Retirement Board') {
            this.IsAutomatciSocial = false
            this.IsAUTOMATIC_RAILROAD = true
            this.IsElectronicFund = false
            this.IsMonthly = false
            this.IsSelectPlan = false
        }
        if (option === 'Automatic Bank Draft Withdrawal') {
            this.IsAutomatciSocial = false
            this.IsAUTOMATIC_RAILROAD = false
            this.IsElectronicFund = true
            this.IsMonthly = false
            this.IsSelectPlan = false
        }
        if (option === 'Direct Bill') {
            this.IsAutomatciSocial = false
            this.IsAUTOMATIC_RAILROAD = false
            this.IsElectronicFund = false
            this.IsMonthly = true
            this.IsSelectPlan = false
        }
        this.enrollmentViewModel.PWO = option
    }
    resetEmergencyDeatils() {
        this.enrollmentViewModel.EMERNAME = ''
        this.enrollmentViewModel.EMERPHONE = ''
        this.enrollmentViewModel.EMERREL = ''
    }
    resetBankDeatils() {
        this.enrollmentViewModel.ACCHOLDERNAME = ''
        this.enrollmentViewModel.EFTTYPE = ''
        this.enrollmentViewModel.FININSTNAME = ''
        this.enrollmentViewModel.ROUTINGNB = ''
        this.enrollmentViewModel.ACCOUNTNB = ''

        //this.paymentAccount.holderName = ''
        //this.paymentAccount.institution = ''
        //this.paymentAccount.number = ''
        //this.paymentAccount.routingNumber = ''
        //this.paymentAccount.type = null
        //this.paymentAccount = {} as PaymentAccount
        //this.enrollment.paymentAccount = this.paymentAccount
    }
    ShowCoverageInfo(val: any) {
        if (val === 'Yes') {
            this.IsCovergInfoYes = true
            this.IsCovergInfotext = true
            //   this.showsubmit = true
        }
        if (val === 'No') {
            this.IsCovergInfoYes = false
            this.IsCovergInfotext = false
            //  this.showsubmit = true
        }
        this.enrollmentViewModel.OTHCVRG = val
    }
    ShowrbllongtermOptions(val: any) {
        if (val === 'Yes') {
            this.IsRbllongtermYes = true
        }
        if (val === 'No') {
            this.IsRbllongtermYes = false
        }
        this.enrollmentViewModel.RBLLONGTERM = val
    }
    ShowrEmergencyContactOptions(val: any) {
        if (val === 'Yes') {
            this.IsEmergencyYes = true
        }
        if (val === 'No') {
            this.IsEmergencyYes = false
        }
        this.enrollmentViewModel.EMERIND = val
    }
    isFormInvalid(): boolean {
        this.hasError = false
        //let HICNregex = new RegExp('[1-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z 0-9][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z 0-9][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z][0-9][0-9]')

        //let validHICN = HICNregex.test(this.enrollmentViewModel.HICN)
        //if (!validHICN) {
        //    this.ErrorMessages.push('Invalid Medicare Number Format')
        //    this.hasError = true
        //}
        if (this.enrollmentViewModel.APPFN === undefined || this.enrollmentViewModel.APPFN === '') {
            this.ErrorMessages.push('First Name is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPLN === undefined || this.enrollmentViewModel.APPLN === '') {
            this.ErrorMessages.push('Last Name is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.APPDOB === undefined || this.enrollmentViewModel.APPDOB === null) {
            this.ErrorMessages.push('Date of Birth is required')
            this.hasError = true
        } else {
            let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY')

            if (dob.isSameOrBefore('12/31/1889')) {
                this.hasError = true
                this.ErrorMessages.push('Invalid Date of Birth.')
            } else {
                if (!isMMDDYYYY(this.enrollmentViewModel.APPDOB.toString())) {
                    this.ErrorMessages.push('Date of Birth does not contain a valid Date')
                    this.hasError = true
                }
                if (dob > moment()) {
                    this.ErrorMessages.push('Date of Birth cannot be in the future')
                    this.hasError = true
                }
            }
        }

        if (this.enrollmentViewModel.APPGEN === undefined || this.enrollmentViewModel.APPGEN === '') {
            this.ErrorMessages.push('Sex is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.APPADD1 === undefined || this.enrollmentViewModel.APPADD1 === '') {
            this.ErrorMessages.push('Permanent Address is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPCITY === undefined || this.enrollmentViewModel.APPCITY === '') {
            this.ErrorMessages.push('City is required')
            this.hasError = true
        } else {
            let regexCityVal = /^[A-Za-z\s\-.]+$/

            let isCityValid = regexCityVal.test(this.enrollmentViewModel.APPCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid City')
            }
        }

        if (this.enrollmentViewModel.APPST === undefined || this.enrollmentViewModel.APPST === '' || this.enrollmentViewModel.APPST === '0') {
            this.ErrorMessages.push('State is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPZIP === undefined || this.enrollmentViewModel.APPZIP === '') {
            this.ErrorMessages.push('Zip is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.ELECTION !== undefined) {
            if (this.enrollmentViewModel.ELECTION === 'Special') {
                if (this.enrollmentViewModel.SEPEFFDT === undefined || this.enrollmentViewModel.SEPEFFDT === null) {
                    this.ErrorMessages.push('Election Option date is required')
                    this.hasError = true
                }
            }
        }

        if (this.enrollmentViewModel.ELECTION === undefined || this.enrollmentViewModel.ELECTION === '') {
            this.ErrorMessages.push('Election Status is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.MAILADD1 === undefined || this.enrollmentViewModel.MAILADD1 === '') {
            this.ErrorMessages.push('Mailing Address is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.MAILCITY === undefined || this.enrollmentViewModel.MAILCITY === '') {
            this.ErrorMessages.push('Mailing City is required')
            this.hasError = true
        } else {
            let regexCityVal = /^[A-Za-z\s\-.]+$/

            let isCityValid = regexCityVal.test(this.enrollmentViewModel.MAILCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid Mailing City')
            }
        }
        if (this.enrollmentViewModel.MAILST === undefined || this.enrollmentViewModel.MAILST === '' || this.enrollmentViewModel.MAILST === '0') {
            this.ErrorMessages.push('Mailing State is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.MAILZIP === undefined || this.enrollmentViewModel.MAILZIP === '') {
            this.ErrorMessages.push('Mailing Zip is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.APPDT === undefined || this.enrollmentViewModel.APPDT === null) {
            this.ErrorMessages.push('Application Date is required')
            this.hasError = true
        }
        //if (this.enrollmentViewModel.PLANST === undefined || this.enrollmentViewModel.PLANST === null) {
        //    this.ErrorMessages.push('Plan State is required')
        //    this.hasError = true

        //}

        if (this.enrollmentViewModel.HICN === undefined || this.enrollmentViewModel.HICN === null || this.enrollmentViewModel.HICN === '') {
            this.ErrorMessages.push('Medicare Number is required')
            this.hasError = true
        } else if (this.enrollmentViewModel.HICN.indexOf('-') > -1) {
            this.ErrorMessages.push('Please enter Medicare Number without -')
            this.hasError = true
        }

        /*
        if (this.enrollmentViewModel.CURRENTGENDER == "4" && (this.enrollment.CURRENTGENDEROTH == undefined
            || this.enrollment.CURRENTGENDEROTH == '')) {
            this.ErrorMessages.push('Different Gender Identity Required')
            this.hasError = true

        }
        if (this.enrollmentViewModel.GENDERNPRONOUN == "4" && (this.enrollment.GENDERNPRONOUNOTH == undefined
            || this.enrollment.GENDERNPRONOUNOTH == '')) {
            this.ErrorMessages.push('Different Self-Identity is Required')
            this.hasError = true

        }
        * /

        //if (this.enrollmentViewModel.LANG === undefined || this.enrollmentViewModel.LANG === null) {
        //    this.ErrorMessages.push('Preferred Language is required')
        //    this.hasError = true

        //}

        if (this.enrollmentViewModel.EFFDT === undefined || this.enrollmentViewModel.EFFDT === null) {
            this.ErrorMessages.push('Effective Date is required')
            this.hasError = true

        }
        else {


            if (this.enrollmentViewModel.EFFDT.getDate() != 1) {
                this.ErrorMessages.push('The Effective Date must fall on the first of the month.')
                this.hasError = true

            }
            if (this.enrollmentViewModel.EFFDT.getFullYear() != this._global.selectedPlanYear) {
                this.ErrorMessages.push('The Effective Date must be in the same year as the Plan Year')
                this.hasError = true

            }
            //if (this.enrollmentViewModel.EFFDT <= this.enrollmentViewModel.APPDT) {
            //    this.ErrorMessages.push('Application date must be prior to the effective date.')
            //    this.hasError = true

            //}
            // var date = new Date()
            //if (this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() - 1) || this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() + 3)) {
            //    this.ErrorMessages.push('The Effective Date can be 1 month before the current month and 3 months after the current month.')
            //    this.hasError = true

            //}
        }

        if (this.enrollmentViewModel.PLANTYPE === undefined || this.enrollmentViewModel.PLANTYPE === '') {
            this.ErrorMessages.push('Plan Type is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.PWO === undefined || this.enrollmentViewModel.PWO === null) {
            this.ErrorMessages.push('Premium Payment is required')
            this.hasError = true

        }
        if (this.enrollmentViewModel.OTHCVRG === undefined || this.enrollmentViewModel.OTHCVRG === '') {
            this.ErrorMessages.push('Secondary Coverage is required')
            this.hasError = true

        }
        else {
            if (this.enrollmentViewModel.OTHCVRG !== undefined && this.enrollmentViewModel.OTHCVRG.toString().toLowerCase() === 'yes') {
                if (this.enrollmentViewModel.OTHCVRGNAME === undefined || this.enrollmentViewModel.OTHCVRGNAME === '') {
                    this.ErrorMessages.push('Other Coverage Name is required')
                    this.hasError = true
                }
                if (this.enrollmentViewModel.OTHCVRGNAME !== undefined && this.enrollmentViewModel.OTHCVRGNAME !== '' && this.enrollmentViewModel.OTHCVRGNAME !== null) {
                    let checkONAme = this.enrollmentViewModel.OTHCVRGNAME,
                        regexONameVal = /^[A-Za-z\s\-\' ]+$/
                    let isONAMEValid = regexONameVal.test(checkONAme)
                    if (!isONAMEValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage Name is invalid')
                    }
                }
                if (this.enrollmentViewModel.OTHCVRGID !== undefined && this.enrollmentViewModel.OTHCVRGID !== '' && this.enrollmentViewModel.OTHCVRGID !== null) {
                    let checkOID = this.enrollmentViewModel.OTHCVRGID,
                        regexOID = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isOIDValid = regexOID.test(checkOID)
                    if (!isOIDValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage ID is invalid')
                    }
                }
                if (this.enrollmentViewModel.OTHCVRGGRP !== undefined && this.enrollmentViewModel.OTHCVRGGRP !== '' && this.enrollmentViewModel.OTHCVRGGRP !== null) {
                    let checkOTHCVRGGRP = this.enrollmentViewModel.OTHCVRGGRP,
                        regexOTHCVRGGRP = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isOGRPValid = regexOTHCVRGGRP.test(checkOTHCVRGGRP)
                    if (!isOGRPValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage Group is invalid')
                    }
                }
            }
        }

        if (this.enrollmentViewModel.PWO === 'Automatic Bank Draft Withdrawal') {


            if (this.enrollmentViewModel.ACCHOLDERNAME === undefined || this.enrollmentViewModel.ACCHOLDERNAME === '' || this.enrollmentViewModel.ACCHOLDERNAME === null) {
                this.ErrorMessages.push('Please enter valid Account Name')
                this.hasError = true

            }
            if (this.enrollmentViewModel.ACCHOLDERNAME !== undefined && this.enrollmentViewModel.ACCHOLDERNAME !== '' && this.enrollmentViewModel.ACCHOLDERNAME !== null) {
                let checkACCHOLDERNAME = this.enrollmentViewModel.ACCHOLDERNAME,
                    regexACCHOLDERNAMEVal = new RegExp('^[a-zA-Z0-9 -. \']*$')
                let isACCHOLDERNAMEValid = regexACCHOLDERNAMEVal.test(checkACCHOLDERNAME)
                if (!isACCHOLDERNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Account Name on Bank Account is invalid')
                }
            }
            if (this.enrollmentViewModel.EFTTYPE === undefined || this.enrollmentViewModel.EFTTYPE === '') {
                this.ErrorMessages.push('Please select Account type')
                this.hasError = true

            }
            if (this.enrollmentViewModel.FININSTNAME === undefined || this.enrollmentViewModel.FININSTNAME === '' || this.enrollmentViewModel.FININSTNAME === null) {
                this.ErrorMessages.push('Please enter valid Financial Institution')
                this.hasError = true

            }
            if (this.enrollmentViewModel.FININSTNAME !== undefined && this.enrollmentViewModel.FININSTNAME !== '' && this.enrollmentViewModel.FININSTNAME !== null) {
                let checkFININSTNAME = this.enrollmentViewModel.FININSTNAME,
                    regexFININSTNAME = new RegExp('^[a-zA-Z0-9 -. \']*$')
                let isFININSTNAMEValid = regexFININSTNAME.test(checkFININSTNAME)
                if (!isFININSTNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Financial Institution on Bank Account is invalid')
                }
            }
            if (this.enrollmentViewModel.ROUTINGNB === undefined || this.enrollmentViewModel.ROUTINGNB === '' || this.enrollmentViewModel.ROUTINGNB == null) {
                this.ErrorMessages.push('Please enter valid Routing Number')
                this.hasError = true

            }
            if (this.enrollmentViewModel.ROUTINGNB !== undefined && this.enrollmentViewModel.ROUTINGNB !== '' && this.enrollmentViewModel.ROUTINGNB !== null) {
                let checkROUTINGNB = this.enrollmentViewModel.ROUTINGNB,
                    regexROUTINGNB = new RegExp('^[0-9]*$')
                let isROUTINGNBValid = regexROUTINGNB.test(checkROUTINGNB)
                if (!isROUTINGNBValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Routing Number is invalid')
                }
            }
            if (this.enrollmentViewModel.ROUTINGNB !== undefined && this.enrollmentViewModel.ROUTINGNB !== '' && this.enrollmentViewModel.ROUTINGNB !== null) {
                if (this.enrollmentViewModel.ROUTINGNB.length !== 9) {
                    this.hasError = true
                    this.ErrorMessages.push('Routing number must be 9 numbers')
                }
            }

            if (this.enrollmentViewModel.ACCOUNTNB === undefined || this.enrollmentViewModel.ACCOUNTNB === '') {
                this.ErrorMessages.push('Please enter valid Account Number')
                this.hasError = true

            }
            if (this.enrollmentViewModel.ACCOUNTNB !== undefined && this.enrollmentViewModel.ACCOUNTNB !== '' && this.enrollmentViewModel.ACCOUNTNB !== null) {
                let checkACCOUNTNB = this.enrollmentViewModel.ACCOUNTNB,
                    regexACCOUNTNB = new RegExp('[0-9]{6}')
                let isACCOUNTNBValid = regexACCOUNTNB.test(checkACCOUNTNB)
                if (!isACCOUNTNBValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Account Number is invalid')
                }
            }
        }
        if (this.enrollmentViewModel.RBLLONGTERM === undefined || this.enrollmentViewModel.RBLLONGTERM === null || this.enrollmentViewModel.RBLLONGTERM === '') {
            this.ErrorMessages.push('Long Term Care Facility is required')
            this.hasError = true

        }
        if (this.enrollmentViewModel.RBLLONGTERM === 'Yes') {
            if (this.enrollmentViewModel.LTCFACILITY === undefined || this.enrollmentViewModel.LTCFACILITY === '') {
                this.ErrorMessages.push('Long Term Care Name is required.')
                this.hasError = true
            }
        }

        if (this.showSTCOBFields) {
            if (this.enrollmentViewModel.SECMBRID === undefined || this.enrollmentViewModel.SECMBRID === '') {
                this.ErrorMessages.push('Secondary Member ID is required.')
                this.hasError = true
            } else if (!this.isAlphaNumeric(this.enrollmentViewModel.SECMBRID)) {
                this.ErrorMessages.push('Secondary Member ID should not have special characters.')
                this.hasError = true
            }

            if (this.enrollmentViewModel.RELCD === undefined || this.enrollmentViewModel.RELCD === '') {
                this.ErrorMessages.push('Relationship Code is required.')
                this.hasError = true
            }

            if (this.enrollmentViewModel.FAMILYID === undefined || this.enrollmentViewModel.FAMILYID === '') {
                this.ErrorMessages.push('Family ID is required.')
                this.hasError = true
            } else if (!this.isAlphaNumeric(this.enrollmentViewModel.FAMILYID)) {
                this.ErrorMessages.push('Family ID should not have special characters.')
                this.hasError = true
            }

            if (this.enrollmentViewModel.PERSONCD === undefined || this.enrollmentViewModel.PERSONCD === '') {
                this.ErrorMessages.push('Person Code is required.')
                this.hasError = true
            }

            if (this.enrollmentViewModel.CAREFAC != undefined
                && this.enrollmentViewModel.CAREFAC != '') {
                if (!this.isAlphaNumeric(this.enrollmentViewModel.CAREFAC)) {
                    this.ErrorMessages.push('Care Facility should not have special characters.')
                    this.hasError = true
                }
            }
        }

        if (this.enrollmentViewModel.EMERIND === undefined || this.enrollmentViewModel.EMERIND === null || this.enrollmentViewModel.EMERIND === '') {
            this.ErrorMessages.push('Emergency Contact is required')
            this.hasError = true

        }
        if (this.enrollmentViewModel.EMERIND === 'Yes') {
            if (this.enrollmentViewModel.EMERNAME === undefined || this.enrollmentViewModel.EMERNAME === '') {
                this.ErrorMessages.push('Emergency Contact Name is required.')
                this.hasError = true
            }
            if (this.enrollmentViewModel.EMERPHONE === undefined || this.enrollmentViewModel.EMERPHONE === '') {
                this.ErrorMessages.push('Emergency Phone is required.')
                this.hasError = true
            }
            if (this.enrollmentViewModel.EMERREL === undefined || this.enrollmentViewModel.EMERREL === '') {
                this.ErrorMessages.push('Emergency Relationship is required.')
                this.hasError = true
            }
        }


        if (this.enrollmentViewModel.APPFN !== undefined && this.enrollmentViewModel.APPFN !== '' && this.enrollmentViewModel.APPFN !== null) {
            let checkFName = this.enrollmentViewModel.APPFN,
                regexFNameVal = new RegExp('^[a-zA-Z.\' ]*$')
            let isFnameValid = regexFNameVal.test(checkFName)
            if (!isFnameValid) {
                this.hasError = true
                this.ErrorMessages.push('First Name is invalid')
            }
        }

        if (this.enrollmentViewModel.APPLN !== undefined && this.enrollmentViewModel.APPLN !== '' && this.enrollmentViewModel.APPLN !== null) {
            let checkLName = this.enrollmentViewModel.APPLN,
                regexFNameVal = new RegExp('^[a-zA-Z.\' -]*$')
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasError = true
                this.ErrorMessages.push('Last Name is invalid')
            }
        }
        if (this.enrollmentViewModel.APPMI !== undefined && this.enrollmentViewModel.APPMI !== '' && this.enrollmentViewModel.APPMI !== null) {
            let checkMI = this.enrollmentViewModel.APPMI,
                regexMIVal = new RegExp('^[a-zA-Z ]*$')
            let isMiValid = regexMIVal.test(checkMI)
            if (!isMiValid) {
                this.hasError = true
                this.ErrorMessages.push('MI is invalid')
            }
        }
        if (this.enrollmentViewModel.SUFFIX !== undefined && this.enrollmentViewModel.SUFFIX !== '') {
            let checkSuffix = this.enrollmentViewModel.SUFFIX,
                regexSuffixVal = new RegExp('^[a-zA-Z. 0-9]*$')
            let isSuffixValid = regexSuffixVal.test(checkSuffix)
            if (!isSuffixValid) {
                this.hasError = true
                this.ErrorMessages.push('Suffix is invalid')
            }
        }
        if (this.enrollmentViewModel.APPZIP !== undefined && this.enrollmentViewModel.APPZIP !== '' && this.enrollmentViewModel.APPZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.APPZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Zip is invalid')
            }
        }
        if (this.enrollmentViewModel.MAILZIP !== undefined && this.enrollmentViewModel.MAILZIP !== '' && this.enrollmentViewModel.MAILZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.MAILZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Mailing Zip is invalid')
            }
        }

        if (this.enrollmentViewModel.APPPHONE !== undefined && this.enrollmentViewModel.APPPHONE !== '' && this.enrollmentViewModel.APPPHONE !== null) {
            let checkOrgPhone = this.enrollmentViewModel.APPPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {

            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                    this.hasError = true

                }
                else {
                    this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        if (this.enrollmentViewModel.LTCFACILITY !== undefined && this.enrollmentViewModel.LTCFACILITY !== '' && this.enrollmentViewModel.LTCFACILITY !== null) {
            let checkLName = this.enrollmentViewModel.LTCFACILITY,
                regexFNameVal = new RegExp('^[a-zA-Z.\' -]*$')
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasError = true
                this.ErrorMessages.push('Long Term Care Name is invalid')
            }
        }
        if (this.enrollmentViewModel.LTCPHONE !== undefined && this.enrollmentViewModel.LTCPHONE !== '' && this.enrollmentViewModel.LTCPHONE !== null) {
            let checkLTCPhone = this.enrollmentViewModel.LTCPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkLTCPhone)) {

            } else {
                if (!this.isValidNumber(checkLTCPhone)) {
                    this.ErrorMessages.push('Long-Term care facility phone cannot contain letters or special characters.')
                    this.hasError = true

                }
                else {
                    this.ErrorMessages.push('Long-Term care facility Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        if (this.enrollmentViewModel.EMERNAME !== undefined && this.enrollmentViewModel.EMERNAME !== '' && this.enrollmentViewModel.EMERNAME !== null) {
            let checkLName = this.enrollmentViewModel.EMERNAME,
                regexFNameVal = new RegExp('^[a-zA-Z.\' -]*$')
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasError = true
                this.ErrorMessages.push('Emergency Contact Name is invalid')
            }
        }
        if (this.enrollmentViewModel.EMERPHONE !== undefined && this.enrollmentViewModel.EMERPHONE !== '' && this.enrollmentViewModel.EMERPHONE !== null) {
            let checkOrgPhone = this.enrollmentViewModel.EMERPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {

            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Emergency Phone cannot contain letters or special characters.')
                    this.hasError = true

                }
                else {
                    this.ErrorMessages.push('Emergency Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }

       /*
        if (this.enrollmentViewModel.EOB === '3') {

            if (this.enrollmentViewModel.APPEMAIL === undefined || this.enrollmentViewModel.APPEMAIL === '') {
                this.ErrorMessages.push('Email Address is required for Paperless Documents')
                this.hasError = true
            }
            else {

                let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
                let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

                let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                if (!isOrgEmailValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Invalid Email address for Paperless Documents')
                }
            }
        }
        
        if (this.enrollmentViewModel.EOB === undefined || this.enrollmentViewModel.EOB.toString().toLowerCase() === 'n') {
            if (this.enrollmentViewModel.APPEMAIL !== undefined && this.enrollmentViewModel.APPEMAIL !== '') {
                let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
                let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

                let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                if (!isOrgEmailValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Invalid Email address for Paperless Documents')
                }
            }
        }
        */
        let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY', true)

        if (dob.isSameOrBefore('1889-12-31')) {
            this.hasError = false
            this.ErrorMessages.push('Invalid Date of Birth.')
        }
        return this.hasError
    }

    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }
    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }
    private isAlphaNumeric(text: string): boolean {
        return /^[A-Za-z0-9 ]+$/.test(text)
    }

    incompleteClick() {
        // do incomplete validations
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        this.ErrorMessages = [] as any[]
        this.hasIncompleteError = false
        if (this.enrollmentViewModel.PWO !== 'Automatic Bank Draft Withdrawal') {
            this.resetBankDeatils()
        }
        if (this.enrollmentViewModel.EMERIND !== null && this.enrollmentViewModel.EMERIND !== undefined) {
            if (this.enrollmentViewModel.EMERIND.toUpperCase() === 'NO') {
                this.resetEmergencyDeatils()
            }
        }
        if (this.enrollmentViewModel.COBEFFDT === undefined) {
            this.enrollmentViewModel.COBEFFDT = null
        }
        if (this.enrollmentViewModel.COBTERMDT === undefined) {
            this.enrollmentViewModel.COBTERMDT = null
        }
        if (this.enrollmentViewModel.OTHCVRG !== null && this.enrollmentViewModel.OTHCVRG !== undefined) {
            if (this.enrollmentViewModel.OTHCVRG.toUpperCase() === 'NO') {
                this.enrollmentViewModel.COBBIN = ''
                this.enrollmentViewModel.COBPCN = ''
                this.enrollmentViewModel.OTHCVRGNAME = ''
                this.enrollmentViewModel.OTHCVRGID = ''
                this.enrollmentViewModel.OTHCVRGGRP = ''
                this.enrollmentViewModel.COBTERMDT = null
                this.enrollmentViewModel.COBEFFDT = null
            }
        }
        if (this.enrollmentViewModel.ISSAMEADDRESS) {
            this.enrollmentViewModel.MAILADD1 = this.enrollmentViewModel.APPADD1
            this.enrollmentViewModel.MAILADD2 = this.enrollmentViewModel.APPADD2
            this.enrollmentViewModel.MAILCITY = this.enrollmentViewModel.APPCITY
            this.enrollmentViewModel.MAILST = this.enrollmentViewModel.APPST
            this.enrollmentViewModel.MAILZIP = this.enrollmentViewModel.APPZIP
        }
        if (!this.incompleteClickValidation()) {
            this.enrollmentViewModel.SUBMISSIONTYPECODE = 'INCOMPLETE'
            this.enrollmentViewModel.PLANYEAR = String(this._global.selectedPlanYear)
            this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
            this.router.navigate(['/' + insCo + '/enrollment/neje/data-entry/Step3'])
        } else {
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        }
    }
    incompleteClickValidation(): boolean {
        if (this.enrollmentViewModel.APPDT === undefined || this.enrollmentViewModel.APPDT === null) {
            this.ErrorMessages.push('Application Date is required')
            this.hasIncompleteError = true
        }
        if (this.enrollmentViewModel.EFFDT === undefined || this.enrollmentViewModel.EFFDT === null) {
            this.ErrorMessages.push('Effective Date is required')
            this.hasIncompleteError = true
        } else {
            if (this.enrollmentViewModel.EFFDT.getFullYear() != this._global.selectedPlanYear) {
                this.ErrorMessages.push('The Effective Date must be in the same year as the Plan Year')
                this.hasIncompleteError = true
            }

            if (this.enrollmentViewModel.EFFDT.getDate() != 1) {
                this.ErrorMessages.push('The Effective Date must fall on the first of the month.')
                this.hasIncompleteError = true
            }
            if (this.enrollment.APPDT && this.enrollmentViewModel.EFFDT <= this.enrollment.APPDT) {
                this.ErrorMessages.push('Application date must be prior to the effective date.')
                this.hasIncompleteError = true
            }
        }
        if (this.enrollmentViewModel.ELECTION !== undefined && this.enrollmentViewModel.ELECTION !== '') {
            if (this.enrollmentViewModel.SEPREASONTEXT === undefined || this.enrollmentViewModel.SEPREASONTEXT === '') {
                this.ErrorMessages.push('Enrollment Criteria is required')
                this.hasIncompleteError = true
            }
        }

        //if (this.enrollmentViewModel.APPCITY !== undefined && this.enrollmentViewModel.APPCITY !== '') {
        //    let regexCityVal = /^[A-Za-z\s\-.]+$/
        if (this.enrollmentViewModel.APPCITY !== undefined && this.enrollmentViewModel.APPCITY !== '') {
            let regexCityVal = /^[A-Za-z\s\-.]+$/

            //    let isCityValid = regexCityVal.test(this.enrollmentViewModel.APPCITY)
            //    if (!isCityValid) {
            //        this.hasIncompleteError = true
            //        this.ErrorMessages.push('Please enter valid City')
            //    }
            //}
            let isCityValid = regexCityVal.test(this.enrollmentViewModel.APPCITY)
            if (!isCityValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Please enter valid City')
            }
        }

        if (this.enrollmentViewModel.MAILCITY !== undefined && this.enrollmentViewModel.MAILCITY !== '') {
            let regexCityVal = /^[A-Za-z\s\-.]+$/

            let isCityValid = regexCityVal.test(this.enrollmentViewModel.MAILCITY)
            if (!isCityValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Please enter valid Mailing City')
            }
        }

        if (this.enrollmentViewModel.APPDOB === undefined || this.enrollmentViewModel.APPDOB === null) {
            this.ErrorMessages.push('Date of Birth is required')
            this.hasIncompleteError = true
        } else {
            if (this.enrollmentViewModel.APPDOB.toString() !== '') {
                let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY')

                if (dob.isSameOrBefore('12/31/1889')) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Invalid Date of Birth.')
                } else {
                    if (!isMMDDYYYY(this.enrollmentViewModel.APPDOB.toString())) {
                        this.ErrorMessages.push('Date of Birth does not contain a valid Date')
                        this.hasIncompleteError = true
                    }
                    if (dob > moment()) {
                        this.ErrorMessages.push('Date of Birth cannot be in the future')
                        this.hasIncompleteError = true
                    }
                }
            }
        }

        if (this.enrollmentViewModel.EFFDT !== undefined && this.enrollmentViewModel.EFFDT !== null) {
            if (this.enrollmentViewModel.EFFDT.getDate() != 1) {
                this.ErrorMessages.push('The Effective Date must fall on the first of the month.')
                this.hasIncompleteError = true
            }
            if (this.enrollmentViewModel.APPDT && this.enrollmentViewModel.EFFDT <= this.enrollmentViewModel.APPDT) {
                this.ErrorMessages.push('Application date must be prior to the effective date.')
                this.hasIncompleteError = true
            }
        }

        if (this.enrollmentViewModel.PWO === 'Automatic Bank Draft Withdrawal') {
            if (
                this.enrollmentViewModel.ACCHOLDERNAME !== undefined &&
                this.enrollmentViewModel.ACCHOLDERNAME !== '' &&
                this.enrollmentViewModel.ACCHOLDERNAME !== null
            ) {
                let checkACCHOLDERNAME = this.enrollmentViewModel.ACCHOLDERNAME,
                    regexACCHOLDERNAMEVal = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isACCHOLDERNAMEValid = regexACCHOLDERNAMEVal.test(checkACCHOLDERNAME)
                if (!isACCHOLDERNAMEValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Account Name on Bank Account is invalid')
                }
            }

            if (
                this.enrollmentViewModel.FININSTNAME !== undefined &&
                this.enrollmentViewModel.FININSTNAME !== '' &&
                this.enrollmentViewModel.FININSTNAME !== null
            ) {
                let checkFININSTNAME = this.enrollmentViewModel.FININSTNAME,
                    regexFININSTNAME = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isFININSTNAMEValid = regexFININSTNAME.test(checkFININSTNAME)
                if (!isFININSTNAMEValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Financial Institution on Bank Account is invalid')
                }
            }

            if (
                this.enrollmentViewModel.ROUTINGNB !== undefined &&
                this.enrollmentViewModel.ROUTINGNB !== '' &&
                this.enrollmentViewModel.ROUTINGNB !== null
            ) {
                let checkRoutingNb = this.enrollmentViewModel.ROUTINGNB,
                    regexVal = new RegExp('[0-9]{9}')
                let isRoutingNbrValid = regexVal.test(checkRoutingNb)
                if (!isRoutingNbrValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Routing Number is invalid')
                }
            }
            if (
                this.enrollmentViewModel.ROUTINGNB !== undefined &&
                this.enrollmentViewModel.ROUTINGNB !== '' &&
                this.enrollmentViewModel.ROUTINGNB !== null
            ) {
                if (this.enrollmentViewModel.ROUTINGNB.length !== 9) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Routing number must be 9 numbers')
                }
            }

            if (
                this.enrollmentViewModel.ACCOUNTNB !== undefined &&
                this.enrollmentViewModel.ACCOUNTNB !== '' &&
                this.enrollmentViewModel.ACCOUNTNB !== null
            ) {
                let checkACCOUNTNB = this.enrollmentViewModel.ACCOUNTNB,
                    regexACCOUNTNB = new RegExp('[0-9]{6}')
                let isACCOUNTNBValid = regexACCOUNTNB.test(checkACCOUNTNB)
                if (!isACCOUNTNBValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Account Number is invalid')
                }
            }
        }

        if (this.enrollmentViewModel.OTHCVRG !== undefined && this.enrollmentViewModel.OTHCVRG !== '') {
            if (this.enrollmentViewModel.OTHCVRG !== undefined && this.enrollmentViewModel.OTHCVRG.toString().toLowerCase() === 'yes') {
                if (
                    this.enrollmentViewModel.OTHCVRGNAME !== undefined &&
                    this.enrollmentViewModel.OTHCVRGNAME !== '' &&
                    this.enrollmentViewModel.OTHCVRGNAME !== null
                ) {
                    let checkONAme = this.enrollmentViewModel.OTHCVRGNAME,
                        regexONameVal = /^[A-Za-z\s\-\' ]+$/
                    let isONAMEValid = regexONameVal.test(checkONAme)
                    if (!isONAMEValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage Name is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.OTHCVRGID !== undefined &&
                    this.enrollmentViewModel.OTHCVRGID !== '' &&
                    this.enrollmentViewModel.OTHCVRGID !== null
                ) {
                    let checkOID = this.enrollmentViewModel.OTHCVRGID,
                        regexOID = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isOIDValid = regexOID.test(checkOID)
                    if (!isOIDValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage ID is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.OTHCVRGGRP !== undefined &&
                    this.enrollmentViewModel.OTHCVRGGRP !== '' &&
                    this.enrollmentViewModel.OTHCVRGGRP !== null
                ) {
                    let checkOTHCVRGGRP = this.enrollmentViewModel.OTHCVRGGRP,
                        regexOTHCVRGGRP = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isOGRPValid = regexOTHCVRGGRP.test(checkOTHCVRGGRP)
                    if (!isOGRPValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage Group is invalid')
                    }
                }
            }
        }

        /*
        if (this.enrollmentViewModel.EOB !== undefined && this.enrollmentViewModel.EOB === '3') {

            if (this.enrollmentViewModel.APPEMAIL !== undefined && this.enrollmentViewModel.APPEMAIL !== '') {

                let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
                let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

                let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                if (!isOrgEmailValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Invalid Email address for Paperless Documents')
                }
            }
        }

        if (this.enrollmentViewModel.EOB !== undefined && this.enrollmentViewModel.EOB.toString().toLowerCase() === 'n') {
            if (this.enrollmentViewModel.APPEMAIL !== undefined && this.enrollmentViewModel.APPEMAIL !== '') {
                let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
                let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()


                let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                if (!isOrgEmailValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Invalid Email address for Paperless Documents')
                }
            }
        }
        */

        if (this.enrollmentViewModel.APPEMAIL !== undefined && this.enrollmentViewModel.APPEMAIL !== '') {
            let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
            let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

            let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
            if (!isOrgEmailValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Invalid Email address for Electronic Explanation of Benefits')
            }
        }

        if (this.enrollmentViewModel.APPFN !== undefined && this.enrollmentViewModel.APPFN !== '' && this.enrollmentViewModel.APPFN !== null) {
            let checkFName = this.enrollmentViewModel.APPFN,
                regexFNameVal = new RegExp("^[a-zA-Z.' ]*$")
            let isFnameValid = regexFNameVal.test(checkFName)
            if (!isFnameValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('First Name is invalid')
            }
        }

        if (this.enrollmentViewModel.APPLN !== undefined && this.enrollmentViewModel.APPLN !== '' && this.enrollmentViewModel.APPLN !== null) {
            let checkLName = this.enrollmentViewModel.APPLN,
                regexFNameVal = new RegExp("^[a-zA-Z.' -]*$")
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Last Name is invalid')
            }
        }
        if (this.enrollmentViewModel.APPMI !== undefined && this.enrollmentViewModel.APPMI !== '' && this.enrollmentViewModel.APPMI !== null) {
            let checkMI = this.enrollmentViewModel.APPMI,
                regexMIVal = new RegExp('^[a-zA-Z ]*$')
            let isMiValid = regexMIVal.test(checkMI)
            if (!isMiValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('MI is invalid')
            }
        }
        if (this.enrollmentViewModel.SUFFIX !== undefined && this.enrollmentViewModel.SUFFIX !== '') {
            let checkSuffix = this.enrollmentViewModel.SUFFIX,
                regexSuffixVal = new RegExp('^[a-zA-Z. 0-9]*$')
            let isSuffixValid = regexSuffixVal.test(checkSuffix)
            if (!isSuffixValid) {
                this.hasError = true
                this.ErrorMessages.push('Suffix is invalid')
            }
        }
        if (this.enrollmentViewModel.HICN !== undefined && this.enrollmentViewModel.HICN !== '' && this.enrollmentViewModel.HICN !== null) {
            if (this.enrollmentViewModel.HICN.indexOf('-') > -1) {
                this.ErrorMessages.push('Please enter Medicare Number without -')
                this.hasError = true
            } else {
                let checkMedicareNum = this.enrollmentViewModel.HICN,
                    regexMedicareNum = new RegExp(
                        '^([1-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z 0-9][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z 0-9][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z][0-9][0-9]){1,10}$'
                    )

                checkMedicareNum = checkMedicareNum.replace(/-/g, '')
                if (checkMedicareNum.length == 10) {
                    let medicareNumError = false
                    var bytes = new Uint8Array(checkMedicareNum.length)
                    for (var i = 0; i < checkMedicareNum.length; i++) {
                        var ascii = checkMedicareNum.charCodeAt(i)
                        bytes[i] = ascii
                    }

                    for (var i = 0; i < bytes.length - 1; i++) {
                        if (!(bytes[i] >= 48 && bytes[i] <= 57)) {
                            medicareNumError = true
                        }
                    }
                    var length = bytes.length - 1
                    if (!((bytes[length] >= 65 && bytes[length] <= 90) || (bytes[length] >= 97 && bytes[length] <= 122))) {
                        medicareNumError = true
                    }

                    if (medicareNumError) {
                        this.hasIncompleteError = true
                        this.ErrorMessages.push('Invalid Medicare Number')
                    }
                } else if (checkMedicareNum.length == 11) {
                    let isMediCareNumValid = regexMedicareNum.test(checkMedicareNum)
                    if (!isMediCareNumValid) {
                        this.hasIncompleteError = true
                        this.ErrorMessages.push('Invalid Medicare Number')
                    }
                } else {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Invalid Medicare Number')
                }
            }
        }

        if (this.enrollmentViewModel.APPZIP !== undefined && this.enrollmentViewModel.APPZIP !== '' && this.enrollmentViewModel.APPZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.APPZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Zip is invalid')
            }
        }
        if (this.enrollmentViewModel.MAILZIP !== undefined && this.enrollmentViewModel.MAILZIP !== '' && this.enrollmentViewModel.MAILZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.MAILZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Mailing Zip is invalid')
            }
        }

        if (
            this.enrollmentViewModel.APPPHONE !== undefined &&
            this.enrollmentViewModel.APPPHONE !== '' &&
            this.enrollmentViewModel.APPPHONE !== null
        ) {
            let checkOrgPhone = this.enrollmentViewModel.APPPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                    this.hasIncompleteError = true
                } else {
                    this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                    this.hasIncompleteError = true
                }
            }
        }

        if (
            this.enrollmentViewModel.LTCPHONE !== undefined &&
            this.enrollmentViewModel.LTCPHONE !== '' &&
            this.enrollmentViewModel.LTCPHONE !== null
        ) {
            let checkLTCPhone = this.enrollmentViewModel.LTCPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkLTCPhone)) {
            } else {
                if (!this.isValidNumber(checkLTCPhone)) {
                    this.ErrorMessages.push('Long-Term care facility phone cannot contain letters or special characters.')
                    this.hasIncompleteError = true
                } else {
                    this.ErrorMessages.push('Long-Term care facility Phone must be exactly 10 numbers.')
                    this.hasIncompleteError = true
                }
            }
        }
        //let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY', true)

        //if (dob.isSameOrBefore('1889-12-31')) {
        //    this.hasIncompleteError = false
        //    this.ErrorMessages.push('Invalid Date of Birth.')
        //}
        return this.hasIncompleteError
    }
    medicareNumberValueChange(event: any) {
        this.enrollmentViewModel.HICN = event.toUpperCase()
    }

    HICNBlur() {
        if (this.enrollmentViewModel.HICN !== undefined && this.enrollmentViewModel.HICN.indexOf('-') >= 0) {
            let re = /\-/gi
            let updatedHICN = this.enrollmentViewModel.HICN.replace(re, '')
            this.enrollmentViewModel.HICN = updatedHICN.toUpperCase()
        }
    }
}
